import { ProductWithAttributes } from '../types';

export const hasAttributes = (
  product: object | null
): product is ProductWithAttributes => {
  return (
    product !== null &&
    typeof product === 'object' &&
    'attributes' in product &&
    (product as ProductWithAttributes).attributes != null
  );
};

export const getAttributeValue = (
  product: ProductWithAttributes | null,
  code: string
): string | undefined => {
  if (!hasAttributes(product)) return undefined;

  const attr = product.attributes?.items?.find((a) => a.code === code);
  if (!attr) return undefined;
  if (attr.value && attr.value !== 'no_selection') return attr.value;
  if (attr.selected_options && attr.selected_options.length > 0) {
    return attr.selected_options[0].value;
  }
  return undefined;
};
